webpackJsonp([112295802909552],{

/***/ 1934:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PlayPackDeferredRevenueItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"PlayPackDeferredRevenueItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-play-pack-deferred-revenue-item-edge-296263bfdcdacade7cc3.js